// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';

export const StyledBodyCopy = styled(BodyCopy)`
  text-align: right;
  position: relative;

  ${(props) =>
    props.isSLP &&
    `@media ${props.theme.mediaQuery.large} {
      display: none;
    }`}
`;

export const ShowLabelStyled = styled.span`
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    display: none;
  }
`;

export const ItemsCountContentNumber = styled.span`
  padding: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
  font-size: ${(props) => props.theme.typography.fontSizes.fs16};
  font-weight: ${(props) => props.theme.typography.fontWeights.extrabold};

  @media ${(props) => props.theme.mediaQuery.large} {
    font-size: ${(props) => props.theme.typography.fontSizes.fs14};
  }

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    &.current-page-product-range {
      display: none;
    }
  }
`;

export const ItemsCountContent = styled.span`
  position: relative;
  z-index: 10;
`;
